import React from "react";
import { IoReloadCircleOutline } from "react-icons/io5";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { formatNumberForIndia } from "./Common";

export default function StatusDetails(props) {
  let ruppysymble = "\u20B9";
  const { transactionStatuswithAmount, sumOfallSatus, statusDate, setStatusDateHandler, reloadTxn, statusFilterHandler } = props;
  console.log('transactionStatuswithAmount', transactionStatuswithAmount)
  return (
    
    <div class="parent">
      {transactionStatuswithAmount !== null &&
        transactionStatuswithAmount !== undefined &&
        transactionStatuswithAmount.length > 0 &&
        transactionStatuswithAmount.map((txnstatus, inde) => {
          const percentage =
            sumOfallSatus == 0 ? 0 : (txnstatus.count * 100) / sumOfallSatus;
          console.log('txnstatus', txnstatus)
          const statusColor =
            txnstatus?.id == "SUCCESS"
              ? `#61bd6d`
              : txnstatus?.id == "FAILED"
              ? `#d9534f`
              : txnstatus?.id == "PENDING"
              ? `#f0ad4e`
              : "primary";
          const statusRailColor =
            txnstatus?.id == "SUCCESS"
              ? `#61bd6d`
              : txnstatus?.id == "FAILED"
              ? `#d9534f`
              : txnstatus?.id == "PENDING"
              ? `#f0ad4e`
              : "00FFFF";
          return (
            <div key={inde} class="relative child">
              <span  onClick={()=>statusFilterHandler(txnstatus?.id)} style={{backgroundColor: statusColor, cursor:'pointer'}} class={`badge badge-pill  mr-1`}>
             
                <p
                  style={{
                    color: "#fff",
                    fontWeight: "bold",
                    fontSize:'15px',
                    paddingTop:'5px'
                  }}
                >
                  { txnstatus?.count !== undefined &&formatNumberForIndia(txnstatus?.count)}
                </p>{" "}
                <p   style={{
                    color: "#fff",
                    fontWeight: "bold",
                    fontSize:'15px',
                    
                  }}>
                {`${ruppysymble}${ txnstatus?.amount !== undefined ? formatNumberForIndia(txnstatus?.amount) : 0}`}
                </p>
              
              </span>
              <div class="absolute">
                <CircularProgressbar
                  styles={buildStyles({
                    pathColor: statusRailColor,
                    textColor: statusRailColor,
                    trailColor: "#ccc",
                    backgroundColor: "#3e98c7",
                  })}
                  value={percentage}
                  text={`${percentage.toFixed(1)}%`}
                />
              </div>
              
            </div>
            
          );
        })}

      <div id='status-reload-and-date'  class="relative child">
          {/* <span class="badge badge-pill bg-danger mr-1"> */}
         
          <div className="status-dates"  >
          <div
                    // style={{ margin: 10 }}
                    class="form-floating float-left"
                    id="select-status-dates"
                  >
                    <input
                      type="date"
                      class="form-control"
                      id="from"
                      placeholder="From Date"
                      onChange={(e)=>setStatusDateHandler(e.target.value)}
                      value={statusDate}
                     
                    />
                    <label style={{ padding: "1rem 1.75rem" }} for="from">
                      Status Date
                    </label>
          </div>
         
          
          </div>
         
          <IoReloadCircleOutline size={45} style={{cursor:'pointer', float:'right'}} onClick={reloadTxn}  />
        </div>
       
    </div>
  );
}
